import { Pipe, PipeTransform } from '@angular/core';
import { interpolate } from '@frontend/unhideschool/app/helpers/utility-functions';

@Pipe({name: 'interpolateString'})
export class InterpolateStringPipe implements PipeTransform {
    transform(str: string, obj: any): string {
        return interpolate(str,obj);
    }
}
